import { render, staticRenderFns } from "./minhas_consultas.vue?vue&type=template&id=fc88fce0&scoped=true"
import script from "./minhas_consultas.vue?vue&type=script&lang=js"
export * from "./minhas_consultas.vue?vue&type=script&lang=js"
import style0 from "./minhas_consultas.vue?vue&type=style&index=0&id=fc88fce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc88fce0",
  null
  
)

export default component.exports